export default __webpack_public_path__ + "static/media/info-icon.ccdf8461.svg";